// ============================================
// INFRASTRUCTURE - Almacen Repository
// ============================================

import { axiosClient } from './axios-client';
import type { PerfilAlmacen, LogoAlmacen } from '../../domain/dtos';

export interface AlmacenSucursal {
  id: number;
  nombre: string;
  rut: number;
  direccion: string;
  numeroDireccion: number;
}

export interface UsuarioLogin {
  usuarioId: number;
  nombreMostrable: string;
  esPropietario: boolean;
}

export const almacenRepository = {
  /**
   * Obtener sucursales de un almacén por RUT (endpoint público)
   */
  async getSucursalesByRut(rutAlmacen: string): Promise<AlmacenSucursal[]> {
    const { data } = await axiosClient.get<AlmacenSucursal[]>(
      `/public/almacenes/by-rut/${rutAlmacen}`
    );
    return data;
  },

  /**
   * Obtener usuarios disponibles para login en una sucursal
   */
  async getUsuariosLogin(almacenId: number): Promise<UsuarioLogin[]> {
    const { data } = await axiosClient.get<UsuarioLogin[]>(
      `/auth/almacenes/${almacenId}/usuarios-login`
    );
    return data;
  },

  /**
   * Obtener perfil del almacén del usuario autenticado
   */
  async getPerfilAlmacen(): Promise<PerfilAlmacen> {
    const { data } = await axiosClient.get<PerfilAlmacen>('/almacenes/by-user');
    return data;
  },

  /**
   * Obtener logo del almacén del usuario autenticado
   */
  async getLogoAlmacen(): Promise<LogoAlmacen> {
    const { data } = await axiosClient.get<LogoAlmacen>('/almacenes/logo');
    return data;
  },

  /**
   * Eliminar logo del almacén del usuario autenticado
   */
  async eliminarLogoAlmacen(): Promise<void> {
    await axiosClient.delete('/almacenes/logo');
  },

  /**
   * Subir logo del almacén del usuario autenticado
   */
  async subirLogoAlmacen(file: File, colorFondo: string): Promise<LogoAlmacen> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('colorFondo', colorFondo);

    const { data } = await axiosClient.post<LogoAlmacen>('/almacenes/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
};
